import { Component, OnInit } from '@angular/core';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-do-data-imps',
  templateUrl: './do-data-imps.component.html',
  styleUrls: ['./do-data-imps.component.css']
})
export class DoDataImpsComponent implements OnInit {
    public grid?: GridOptions;

    constructor(private stateService: StateService) {

    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_dodataimps_grid')
                .setLoadDataFunction({
                    method: 3173,
                    parameters: {}
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([{
                    name: 'dodataimps_new',
                    text: 'dodataimps_new',
                    tooltip: 'dodataimps_new',
                    translateTooltip: true,
                    func: () => this.stateService?.go('dataimps'),
                    icon: 'fas fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true
                }]);
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}
